export default {"src":"/_next/static/media/toys.a323561c.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};